import React from "react";
import "../../styles/categories.css";

const Categories = () => {
const featureList = [
    {
      id: 1,
      title: "Experienced Faculty",
      desc: "Experts in school-level teaching with proven results.",
      // Image: A teacher explaining a concept in a classroom
      img: "https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 2,
      title: "Small Batch Strength",
      desc: "More attention to every student.",
      // Image: A small group of students studying together intently
      img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 3,
      title: "Daily Tuition Support",
      desc: "Homework guidance & exam preparation.",
      // Image: Student writing in a notebook, focused on homework
      img: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 4,
      title: "Printed & PDF Notes",
      desc: "Easy-to-understand study material.",
      // Image: Organized desk with textbooks, notes, and a tablet
      img: "https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 5,
      title: "Fluency Coaching",
      desc: "Confidence for both academics & life.",
      // Image: People engaging in confident conversation/discussion
      img: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=600&q=80"
    }
  ];

  return (
    <section className="categories-section container">
      {/* Section Title */}
      <h2 className="section-title text-center mb-5">
        Why Madhi Academy for School Students?
      </h2>

      <div className="categories-wrapper">
        {featureList.map((item) => (
          <div key={item.id} className="category-item">
            {/* Image Container */}
            <div className="img-box">
              <img src={item.img} alt={item.title} className="category-img" />
            </div>
            
            {/* Text Content */}
            <h6 className="category-title">{item.title}</h6>
            <p className="category-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Categories;